import {SvgInjector}      from './modules/svgInjector';
import {Parallax}         from './modules/parallax';
import {ImagePopUp}       from './modules/imagePopUp';
import {Carousels}        from './modules/carousels';
import {MiniGallery}      from './modules/miniGallery';
import {DisplayNews}      from './modules/displayNews';
import {Cookies}          from './modules/cookies';
import {ResponsiveImages} from './modules/responsiveImages';
import {HamburgerMenu}    from './modules/hamburgerMenu';
import {ScrollTo}         from './modules/scrollTo';
import {GoogleMaps}       from './modules/googleMaps';
import {Video}            from './modules/video';
import {TabsSection}      from './modules/tabsSection';
import {Validator}        from './modules/validator';
import {SidePanel}        from './modules/sidePanel';
import {Load}             from './modules/load';
import {Accordeon}             from './modules/accordeon';
import {Navigation}             from './modules/navigation';
import {Visible}             from './modules/visible';
import {Sticky}             from './modules/sticky';

var svgInjector       = new SvgInjector();
var parallax          = new Parallax();
var imagePopUp        = new ImagePopUp();
var carousels         = new Carousels();
var miniGallery       = new MiniGallery();
var displayNews       = new DisplayNews();
var cookies           = new Cookies();
var responsiveImages  = new ResponsiveImages();
var hamburgerMenu     = new HamburgerMenu();
var scrollTo          = new ScrollTo();
var googleMaps        = new GoogleMaps();
var video             = new Video();
var tabsSection       = new TabsSection();
var validator         = new Validator();
var sidePanel         = new SidePanel();
var load              = new Load();
var accordeon              = new Accordeon();
var navigation              = new Navigation();
var visible             = new Visible();
var sticky             = new Sticky();

class Main{
  constructor(node_env){
    this.node_env = node_env;
    this.sections = $('.cms-section');
    jcf.setOptions('Select', {
      wrapNative: false,
      maxVisibleItems: 8
    });
    jcf.replaceAll();  }
  bootstrap(callback){
    var $sections = $(this.sections);
    this.modules($sections);
    this.responsiveModules($sections);
    callback();
  }

  modules($sections){
    parallax.init($sections);
    svgInjector.init();
    imagePopUp.init();
    carousels.init();
    miniGallery.init();
    displayNews.init();
    cookies.init();
    responsiveImages.init($sections);
    hamburgerMenu.init();
    scrollTo.init();
    googleMaps.init();
    video.init();
    tabsSection.init();
    validator.init();
    sidePanel.init();
    accordeon.init();
    navigation.init();
    visible.init();
    load.init();
    sticky.init();
  }

  responsiveModules($sections){
    $(window).resize(function(){
      parallax.init($sections);
      carousels.init();
      miniGallery.init();
      displayNews.init();
      responsiveImages.init($sections);
    });

    $(window).scroll(function(){
      $('.video-player').each(function(id, videoPlayer){
        if( $(videoPlayer).visible(true) ){
          video.play($(videoPlayer));
        }else{
          video.stop($(videoPlayer));
        }
      });
    });
  }
    Apartament_rodzinny() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Apartament', pokoj: 'rodzinny', id: ''}); };
    Apartament_2_pokojowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Apartament', pokoj: '2_pokojowy', id: 'room-43051'}); };
    Apartament_3_pokojowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Apartament', pokoj: '3_pokojowy', id: 'room-43052'}); };
    Standard() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Standard', pokoj: '2_osobowy', id: 'room-43053'}); };
    Lux_2_osobowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Lux', pokoj: '2_osobowy', id: 'room-43049'}); };
    Lux_3_osobowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Lux', pokoj: '3_osobowy', id: 'room-43050'}); };
    Classic_Plus_2_osobowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Classic_Plus', pokoj: '2_osobowy', id: 'room-43047'}); };
    Classic_Plus_3_osobowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Classic_Plus', pokoj: '3_osobowy', id: 'room-43048'}); };
    Classic_2_osobowy() { fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Classic', pokoj: '2_osobowy', id: 'room-43046'}); };
    Wakacje_nad_morzem() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Wakacje_nad_morzem', id: 'offer-121990'}); };
    Sylwester_2018_2019_pobyt_4_dniowy() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Sylwester_2018_2019_pobyt_4_dniowy', id: ''}); };
    Sloneczny_wrzesien_nad_morzem() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Sloneczny_wrzesien_nad_morzem', id: 'offer-122000'}); };
    Bal_Sylwestrowy_2018_2019() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Bal_Sylwestrowy_2018_2019', id: ''}); };
    Mini_Bal_Sylwestrowy() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Mini_Bal_Sylwestrowy', id: ''}); };
    Magiczne_Swieta_Bozego_Narodzenia() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Magiczne_Swieta_Bozego_Narodzenia', id: ''}); };
    Urodziny_dla_dzieci_z_Bowlingiem() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Urodziny_dla_dzieci_z_Bowlingiem', id: ''}); };
    Promocja_dla_Firm() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Promocja_dla_Firm', id: ''}); };
    Propozycja_polowinki_grand_2019() { fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Propozycja_polowinki_grand_2019', id: ''}); };
  
}


$(window).load(function(){
  var main = new Main('development');
  main.bootstrap(function(){
    $('#page-overlay').fadeOut(800);
  });
});